module.exports = __webpack_public_path__ + "img/187.ff0ff447.jpg";